const config = {
    apiUrl: process.env.REACT_APP_API_URL,
    shareUrl: process.env.REACT_APP_SHARE_URL,
    recaptcha: process.env.REACT_APP_RECAPTCHA_V2_SITE_KEY
};

export default config;  